import React, { Component } from "react";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Konva from "konva";
import defaultBackground from '../../resources/file/Heatmap_Temp.pdf';
import fontBytes from '../../resources/font/NotoSansCJKjp-Regular.otf';
import * as fontkit from 'fontkit';
import { doGetVisualData } from '../../actions/visual/index';
import _ from 'lodash';
import Loading from '../common/Loading';
class PdfGenerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      heatMap: null,
      devices: [
        { name: "MI10", quantity: 0 },
        { name: "MI11", quantity: 0 },
        { name: "MI12", quantity: 0 },
        { name: "MI13", quantity: 0 },
        { name: "MI14", quantity: 0 }
      ],
      loading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.floorPlanProjectList !== prevProps.floorPlanProjectList &&
      this.props.floorPlanProjectList &&
      this.props.floorPlanProjectList.length > 0
    ) {
      localStorage.setItem("floorPlanProjectList", JSON.stringify(this.props.floorPlanProjectList));
    }
  }

  formatDate(date) {
    const day = date.getDate();
    const suffix = ['st', 'nd', 'rd', 'th'][((day % 10) - 1) % 10] || 'th';
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();
    return `${month} ${day}${suffix}, ${year}`;
  }

  drawCenteredText = (page, text, font, size, y, width) => {
    const textWidth = font.widthOfTextAtSize(text, size);
    const xPosition = (width - textWidth) / 2;
    page.drawText(text, {
      x: xPosition,
      y: y,
      size: size,
      color: rgb(0, 0, 0),
      font: font,
    });
  };

  PdfGenerator = async () => {
    try {
      const { accountInfo, originalImageWidth, originalImageHeight, selectFloorPlanProject, projectAddress } = this.props;
      const { devices } = this.state;

      let PIXEL_RATIO = 3;
      if (this.props.arrayIds.length >= 8) {
        PIXEL_RATIO = 2;
      }
      const pdfDoc = await PDFDocument.create();
      pdfDoc.registerFontkit(fontkit);
      const customFont = await pdfDoc.embedFont(await fetch(fontBytes).then(res => res.arrayBuffer()));
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

      const floorPlanProjectList = JSON.parse(localStorage.getItem("floorPlanProjectList")) || [];
      const floorPlanProject = floorPlanProjectList.find(project => project.seq === parseInt(selectFloorPlanProject))

      const backgroundResponse = await fetch(defaultBackground);
      if (!backgroundResponse.ok) {
        throw new Error('Unable to download background PDF file');
      }
      const backgroundBytes = await backgroundResponse.arrayBuffer();
      const backgroundPdf = await PDFDocument.load(backgroundBytes);
      const [backgroundPage] = await pdfDoc.embedPdf(backgroundPdf);
      const pageSize = [595.28, 841.89];
      const width = pageSize[0];
      const height = pageSize[1];


      //Page 1
      const page1 = pdfDoc.addPage(pageSize);
      page1.drawPage(backgroundPage, { x: 0, y: 0, width, height });

      this.drawCenteredText(page1, "Signal Simulation", font, 35, 500, width);
      this.drawCenteredText(page1, floorPlanProject.name, customFont, 16, 320, width);

      if (projectAddress) {
        const maxLineLength = 64;
        const lines = [];

        for (let i = 0; i < projectAddress.length; i += maxLineLength) {
          lines.push(projectAddress.slice(i, i + maxLineLength));
        }

        let y = 300;
        lines.forEach(line => {
          this.drawCenteredText(page1, line, customFont, 16, y, width);
          y -= 20;
        });
      }

      const dateStr = this.formatDate(new Date());
      this.drawCenteredText(page1, accountInfo.name, customFont, 16, 200, width);
      this.drawCenteredText(page1, dateStr, font, 16, 180, width);
      this.drawCenteredText(page1, "Powered by Prism", font, 12, 90, width);


      // Page 2
      const displayWidth = width - 80 * 2;
      const displayHeight = height - 200 * 2;
      const windowWidth = 1920
      const windowHeight = 993

      const tempDiv = document.createElement("div");

      const { heatmapImg, getImage, originalImageWidthArray, originalImageHeightArray, scaleArray, mappingInteriorGraph, showVirtualDeviceInfo, lines } = this.props;
      for (let index = 0; index < this.props.arrayIds.length; index ++) {
        let id = this.props.arrayIds[index];
        const visual = this.props.visualList.mappingGroups.find(item => item.interiorGraph.id === id);

        let wallData = [];
        let rssiInfo = [];
        const heatMap = heatmapImg.find(item => item.id === id);

        if (visual.interiorGraph.id === mappingInteriorGraph.id) {
          originalImageWidthArray[index] = originalImageWidth
          originalImageHeightArray[index] = originalImageHeight
          rssiInfo = showVirtualDeviceInfo
          wallData = lines
        } else {
          if (visual.wallInfo?.length > 0) {
            wallData = visual.wallInfo.map((e) => ({
              ...e,
              points: e.points.split(",").reduce((z, x) => z.concat(+x ), [])
            }))
          }

          rssiInfo = _.cloneDeep(visual.rssiInfo) 

          rssiInfo = rssiInfo.map(option => ({
            ...option,
            x: option.x * scaleArray[index],
            y: option.y * scaleArray[index]
          }));

          wallData = wallData.map(wall => ({
            ...wall,
            points: wall.points.map(point => point * scaleArray[index])
          }))
        }

        const widthRatio = displayWidth / originalImageWidthArray[index];
        const heightRatio = displayHeight / originalImageHeightArray[index];
        const scaleRatio = Math.min(widthRatio, heightRatio);
        const offsetX = (width - (originalImageWidthArray[index] * scaleRatio)) / 2;
        const offsetY = height - 450;

        const src = `data:image/png;base64,${visual?.interiorGraph.interiorImg}`;
        const backImg = await this.loadImage(src);

        const page2 = pdfDoc.addPage(pageSize);
        page2.drawPage(backgroundPage, { x: 0, y: 0, width, height });
        page2.drawText(`${index + 1}.1. Original Floor Plan`, {
          x: 50,
          y: 670,
          size: 28,
          weight: 'bold',
          color: rgb(0, 0, 0),
        });
  
        const hiddenStagebg = new Konva.Stage({
          container: tempDiv,
          x: offsetX,
          y: offsetY,
          width: windowWidth,
          height: windowHeight,
        });
  
        const layerBg = new Konva.Layer();
  
        if (backImg) {
          const bgImage = new Konva.Image({
            image: backImg,
            x: 0,
            y: 0,
            width: originalImageWidthArray[index],
            height: originalImageHeightArray[index],
          });
          layerBg.add(bgImage);
        }
  
        hiddenStagebg.add(layerBg);
        hiddenStagebg.scale({ x: scaleRatio, y: scaleRatio });
  
        const imgDataURLBg = hiddenStagebg.toDataURL({ pixelRatio: PIXEL_RATIO });
        const imgBytesBg = await fetch(imgDataURLBg).then((res) => res.arrayBuffer());
  
        const img1 = await pdfDoc.embedPng(imgBytesBg);
  
        page2.drawImage(img1, {
          x: 0,
          y: 0,
          width: hiddenStagebg.width(),
          height: hiddenStagebg.height(),
        });

        // Page 3
        let page3 = pdfDoc.addPage(pageSize);
        page3.drawPage(backgroundPage, { x: 0, y: 0, width, height });
        page3.drawText(`${index + 1}.2. Original Floor Plan with devices`, {
          x: 50,
          y: 670,
          size: 28,
          weight: 'bold',
          color: rgb(0, 0, 0),
        });
  
        const hiddenStagePage3 = new Konva.Stage({
          container: tempDiv,
          x: offsetX,
          y: offsetY,
          width: windowWidth,
          height: windowHeight,
        });
  
        const layerPage3 = new Konva.Layer();
  
        if (backImg) {
          const bgImage = new Konva.Image({
            image: backImg,
            width: originalImageWidthArray[index],
            height: originalImageHeightArray[index],
          });
          layerPage3.add(bgImage);
        }
  
        wallData.forEach((line) => {
          const konvaLine = new Konva.Line({
            x: line.x,
            y: line.y,
            points: line.points,
            stroke: line.stroke,
            strokeWidth: line.strokeWidth / 1.5,
          });
          layerPage3.add(konvaLine);
        });
  
        Array.from(rssiInfo).forEach((option) => {
          const rect = new Konva.Rect({
            x: option.x - 15 / scaleRatio,
            y: option.y + 7 / scaleRatio,
            width: 30 / scaleRatio,
            height: 10 / scaleRatio,
            fill: "lightgray",
            cornerRadius: 5,
          });
  
          const text = new Konva.Text({
            text: option.name.length > 7 ? option.name.slice(0, 6) + "..." : option.name,
            x: option.x - 10 / scaleRatio,
            y: option.y + 8 / scaleRatio,
            fontSize: 9 / scaleRatio,
          });
  
          const imageElement = getImage(option.modelName);
          const image = new Konva.Image({
            image: imageElement,
            x: option.x - 7,
            y: option.y - 7,
            width: 10 / scaleRatio,
            height: 10 / scaleRatio,
          });
  
          layerPage3.add(rect);
          layerPage3.add(text);
          layerPage3.add(image);
        });
  
        hiddenStagePage3.add(layerPage3);
        hiddenStagePage3.scale({ x: scaleRatio, y: scaleRatio });

        const imgDataURLPage3 = hiddenStagePage3.toDataURL({ pixelRatio: PIXEL_RATIO });
        const imgBytesPage3 = await fetch(imgDataURLPage3).then((res) => res.arrayBuffer());
        const imgPage3 = await pdfDoc.embedPng(imgBytesPage3);
  
        page3.drawImage(imgPage3, {
          x: 0,
          y: 0,
          width: hiddenStagePage3.width(),
          height: hiddenStagePage3.height(),
        });
        hiddenStagePage3.destroy();

        // Page 4
        const page4 = pdfDoc.addPage(pageSize);
        page4.drawPage(backgroundPage, { x: 0, y: 0, width, height });
        page4.drawText(`${index + 1}.3. Simulation Result`, {
          x: 50,
          y: 670,
          size: 28,
          weight: 'bold',
          color: rgb(0, 0, 0),
        });
  
        const hiddenStage = new Konva.Stage({
          container: tempDiv,
          x: offsetX,
          y: offsetY,
          width: windowWidth,
          height: windowHeight,
        });
  
        const layer = new Konva.Layer();
  
        if (backImg) {
          const bgImage = new Konva.Image({
            image: backImg,
            width: originalImageWidthArray[index],
            height: originalImageHeightArray[index],
          });
          layer.add(bgImage);
        }
  
        wallData.forEach((line) => {
          const konvaLine = new Konva.Line({
            x: line.x,
            y: line.y,
            points: line.points,
            stroke: line.stroke,
            strokeWidth: line.strokeWidth / 1.5,
          });
          layer.add(konvaLine);
        });
  
        if (heatMap.image) {
          const heatMapImage = new Konva.Image({
            image: heatMap.image,
            width: originalImageWidthArray[index],
            height: originalImageHeightArray[index],
          });
          layer.add(heatMapImage);
        }
  
        Array.from(rssiInfo).forEach((option) => {
          const rect = new Konva.Rect({
            x: option.x - 15 / scaleRatio,
            y: option.y + 7 / scaleRatio,
            width: 30 / scaleRatio,
            height: 10 / scaleRatio,
            fill: "lightgray",
            cornerRadius: 5,
          });
  
          const text = new Konva.Text({
            text: option.name.length > 7 ? option.name.slice(0, 6) + "..." : option.name,
            x: option.x - 10 / scaleRatio,
            y: option.y + 8 / scaleRatio,
            fontSize: 9 / scaleRatio,
          });
  
          const imageElement = getImage(option.modelName);
          const image = new Konva.Image({
            image: imageElement,
            x: option.x - 7,
            y: option.y - 7,
            width: 10 / scaleRatio,
            height: 10 / scaleRatio,
          });
  
          layer.add(rect);
          layer.add(text);
          layer.add(image);
        });
  
        hiddenStage.add(layer);
        hiddenStage.scale({ x: scaleRatio, y: scaleRatio });
        const imgDataURL = hiddenStage.toDataURL({ pixelRatio: PIXEL_RATIO - 1 });
        const imgBytes = await fetch(imgDataURL).then((res) => res.arrayBuffer());
        const img = await pdfDoc.embedPng(imgBytes);
  
        page4.drawImage(img, {
          x: 0,
          y: 0,
          width: hiddenStage.width(),
          height: hiddenStage.height(),
        });
  
        // Add legend to page 4
        const legendCanvas = document.createElement('canvas');
        const legendCtx = legendCanvas.getContext('2d');
  
        const gradientCfg = {
          0.1: 'rgb(63, 204, 101)',
          0.3: 'rgb(238, 247, 111)',
          0.45: 'rgb(238, 247, 111)',
          0.95: 'rgb(255, 77, 64)',
        };
  
        const gradient = legendCtx.createLinearGradient(0, 0, 360, 1);
        for (var key in gradientCfg) {
          gradient.addColorStop(key, gradientCfg[key]);
        }
  
        legendCtx.fillStyle = gradient;
        legendCtx.fillRect(0, 20, 360, 20);
        legendCtx.fillStyle = 'black';
        legendCtx.font = '14px Arial';
        legendCtx.textAlign = 'center';
  
        const canvasWidth = legendCanvas.width;
        const strongTextWidth = legendCtx.measureText('Strong').width;
        legendCtx.fillText('Strong', canvasWidth - strongTextWidth + 15, 12);
        legendCtx.fillText('Weak', 18, 12);
  
        const legendBase64 = legendCanvas.toDataURL('image/png');
        const imageBytes1 = await fetch(legendBase64).then(res => res.arrayBuffer());
        const imageLedgend = await pdfDoc.embedPng(imageBytes1);
  
        const legendWidth = 300;
        const legendOffsetY = 5;
        const legendOffsetX = (width - legendWidth) / 2;
  
        page4.drawImage(imageLedgend, {
          x: legendOffsetX,
          y: legendOffsetY,
          width: legendWidth,
          height: 120,
        });
        hiddenStage.destroy();

        // Page 5
        const page5 = pdfDoc.addPage(pageSize);
        const updatedDevices = devices.map(device => {
          const count = rssiInfo.filter(info => info.modelName === device.name).length;
          return { ...device, quantity: count };
        });
        this.setState({ devices: updatedDevices });
  
        page5.drawPage(backgroundPage, { x: 0, y: 0, width, height });
  
        page5.drawText(`${index + 1}.4. Estimated Equipment`, {
          x: 50,
          y: 670,
          size: 28,
          weight: 'bold',
          color: rgb(0, 0, 0),
        });
  
        const headers = ["Name", "Quantity"];
        const rows = this.state.devices.map((device) => [device.name, device.quantity.toString()]);
        const cellWidth = [200, 200];
        const cellHeight = 30;
        const tableWidth = cellWidth.reduce((a, b) => a + b, 0);
        const tableX = (width - tableWidth) / 2;
        const tableY = height - 300;
        let currentY = tableY;
  
        headers.forEach((header, index) => {
          const x = tableX + cellWidth.slice(0, index).reduce((a, b) => a + b, 0);
          page5.drawRectangle({
            x,
            y: currentY - cellHeight,
            width: cellWidth[index],
            height: cellHeight,
            weight: 'bold',
            borderColor: rgb(0, 0, 0),
            borderWidth: 2,
          });
          page5.drawText(header, {
            x: x + 5,
            y: currentY - cellHeight + 5,
            size: 16,
            weight: 'bold',
            color: rgb(0, 0, 0),
          });
        });
  
        rows.forEach((row, rowIndex) => {
          currentY -= cellHeight;
          row.forEach((cell, colIndex) => {
            const x =
              tableX + cellWidth.slice(0, colIndex).reduce((a, b) => a + b, 0);
              page5.drawRectangle({
              x,
              y: currentY - cellHeight,
              width: cellWidth[colIndex],
              height: cellHeight,
              borderColor: rgb(0, 0, 0),
              borderWidth: 2,
              color: rowIndex % 2 === 0 ? rgb(0.95, 0.95, 0.95) : rgb(1, 1, 1),
            });
            page5.drawText(cell, {
              x: x + 5,
              y: currentY - cellHeight + 5,
              size: 16,
              color: rgb(0, 0, 0),
            });
          });
        });
  
        hiddenStagebg.destroy();
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      saveAs(blob, "Heatmap.pdf");
      this.setState({ loading: false });

    } catch (error) {
      alert(`An error occurred while creating PDF: ${error.message}`);
    }
  };

  loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new window.Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  };

  handleExport = async () => {
    const { authToken, selectFloorPlanProject, doGetVisualData } = this.props;
    this.setState({ loading: true });
    await doGetVisualData(authToken, selectFloorPlanProject);
    await this.props.handlePDFHeatmap();

    while (this.props.isLoading) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    await new Promise((resolve) => setTimeout(resolve, 500));

    this.props.setIsExporting(true);
    this.PdfGenerator();
    this.props.setIsExporting(false);
  };

  render() {
    return (
      <>
      <span
          id="floor-plan-toolbar-export-btn"
        className='icon-btn-export'
        onClick={this.handleExport}
        title='Export'
      />
      <div style={{ marginTop: '35px' }}>
        <Loading loading={this.state.loading} />
      </div>

    </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accountRole: state.loginReducers.accountRole,
    roleTableAuth: state.loginReducers.roleTableAuth,
    mappingOrg: state.visualReducers.mappingOrg,
    mappingGroup: state.visualReducers.mappingGroup,
    virtualDeviceInfo: state.visualReducers.virtualDeviceInfo,
    wallInfo: state.visualReducers.wallInfo,
    mappingInteriorGraph: state.visualReducers.mappingInteriorGraph,
    interiorGraphImgUrl: state.visualReducers.interiorGraphImgUrl,
    interiorGraphImgWidth: state.visualReducers.interiorGraphImgWidth,
    accountInfo: state.loginReducers.accountInfo,
    authToken: state.loginReducers.authToken,
    selectSite: state.siteReducers.selectSite,
    heatmapData: state.visualReducers.heatmapData,
    popLoading: state.visualReducers.popLoading,
    isLoading: state.visualReducers.isLoading,
    deviceList: state.visualReducers.deviceList,
    selectFloorPlanProject: state.visualReducers.selectFloorPlanProject,
    selectFloorPlanProjectEnvironment: state.visualReducers.selectFloorPlanProjectEnvironment,
    graphId: state.visualReducers.graphId,
    siteSummaryList: state.siteReducers.siteSummaryList,
    projectAddress: state.visualReducers.projectAddress,
    floorPlan: state.visualReducers.floorPlan,
    visualList: state.visualReducers.visualList,
    heatmapAllData: state.visualReducers.heatmapAllData,
    floorPlanProjectList: state.visualReducers.floorPlanProjectList
  }
}
export default withRouter(connect(
  mapStateToProps,
  {
    doGetVisualData
  }
)(PdfGenerator));
